"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.papConsumer = exports.appsConsumer = exports.roleFields = exports.tenantAdminPolicyName = exports.disabledPolicy = exports.enabledPolicy = exports.getTogglePolicyLabel = exports.getTogglePolicyErrorMessage = exports.getTogglePolicySuccessMessage = exports.getTogglePolicyConfirmMessage = exports.getTogglePolicyConfirmTitle = exports.policyButton = exports.routeToNameList = exports.inactiveStatus = exports.timeFormat = exports.dateFormat = exports.viewPolicyHeaders = exports.approvalLabels = exports.conditionsLabels = exports.memberLabels = exports.policyConstantLabels = exports.translatedStrings = exports.classes = exports.approvalNotificationMediumDetailsType = exports.PolicyDeleteDataTypes = exports.PolicyViewDataTypes = void 0;

var _externalization = require("../../../packages/policy-management/externalization");

var PolicyViewDataTypes = {
  POLICY_VIEW_DATA_REQUEST: 'POLICY_VIEW_DATA_REQUEST',
  POLICY_VIEW_DATA_LOADING: 'POLICY_VIEW_DATA_LOADING',
  POLICY_VIEW_DATA_SUCCESS: 'POLICY_VIEW_DATA_SUCCESS',
  POLICY_VIEW_DATA_FAILURE: 'POLICY_VIEW_DATA_FAILURE',
  POLICY_VIEW_DATA_RESET: 'POLICY_VIEW_DATA_RESET',
  OPEN_NOTIFICATION: 'OPEN_NOTIFICATION',
  POLICY_VIEW_TOGGLE_REQUEST_INIT: 'POLICY_VIEW_TOGGLE_REQUEST_INIT',
  POLICY_VIEW_TOGGLE_REQUEST_LOADING: 'POLICY_VIEW_TOGGLE_REQUEST_LOADING',
  POLICY_VIEW_TOGGLE_REQUEST_COMPLETE: 'POLICY_VIEW_TOGGLE_REQUEST_COMPLETE',
  POLICY_VIEW_TOGGLE_REQUEST_FAILURE: 'POLICY_VIEW_TOGGLE_REQUEST_FAILURE',
  POLICY_VIEW_DATA_JSON_REQUEST: 'POLICY_VIEW_DATA_JSON_REQUEST',
  POLICY_VIEW_DATA_JSON_LOADING: 'POLICY_VIEW_DATA_JSON_LOADING',
  POLICY_VIEW_DATA_JSON_SUCCESS: 'POLICY_VIEW_DATA_JSON_SUCCESS',
  POLICY_VIEW_DATA_JSON_FAILURE: 'POLICY_VIEW_DATA_JSON_FAILURE',
  POLICY_VIEW_DATA_JSON_RESET: 'POLICY_VIEW_DATA_JSON_RESET'
};
exports.PolicyViewDataTypes = PolicyViewDataTypes;
var PolicyDeleteDataTypes = {
  POLICY_DELETE_DATA_REQUEST: 'POLICY_DELETE_DATA_REQUEST',
  POLICY_DELETE_DATA_LOADING: 'POLICY_DELETE_DATA_LOADING',
  POLICY_DELETE_DATA_SUCCESS: 'POLICY_DELETE_DATA_SUCCESS',
  POLICY_DELETE_DATA_FAILURE: 'POLICY_DELETE_DATA_FAILURE',
  OPEN_NOTIFICATION: 'OPEN_NOTIFICATION'
};
exports.PolicyDeleteDataTypes = PolicyDeleteDataTypes;
var approvalNotificationMediumDetailsType = {
  APPROVAL_NOTIFICATION_MEDIUM_DETAILS_REQUEST: 'APPROVAL_NOTIFICATION_MEDIUM_DETAILS_REQUEST',
  APPROVAL_NOTIFICATION_MEDIUM_DETAILS_LOADING: 'APPROVAL_NOTIFICATION_MEDIUM_DETAILS_LOADING',
  APPROVAL_NOTIFICATION_MEDIUM_DETAILS_SUCCESS: 'APPROVAL_NOTIFICATION_MEDIUM_DETAILS_SUCCESS',
  APPROVAL_NOTIFICATION_MEDIUM_DETAILS_FAILURE: 'APPROVAL_NOTIFICATION_MEDIUM_DETAILS_FAILURE',
  APPROVAL_NOTIFICATION_MEDIUM_DETAILS_RESET: 'APPROVAL_NOTIFICATION_MEDIUM_DETAILS_RESET'
};
exports.approvalNotificationMediumDetailsType = approvalNotificationMediumDetailsType;
var classes = {
  buttonMainContainer: 'button-main-container',
  buttonChildContainer: 'child-button-main-container',
  viewPolicyMainContainer: 'view-policy-main-container',
  headerClass: 'header-class',
  marginTop32: 'margin-top-32',
  marginTop8: 'margin-top-8',
  marginTop10: 'margin-top-10',
  tagsContainer: 'tag-container',
  renderClass: 'policy-render-class',
  viewPolicyPermissionActionPillContainer: 'view-policy-permission-action-pill-container',
  addRoleTablePermissions: 'add-role-table-permissions',
  approvalLoaderContainer: 'approval-loader-container',
  viewPolicyOuterWrapper: 'view-policy-outer-wrapper',
  viewRolePolicyDetailsModalWrapper: 'view-role-permission-details-modal-wrapper',
  rolePermissionWrapper: 'role-permission-wrapper',
  addEntityInputSpacing: 'add-entity-input-spacing',
  addEntityModalLabel: 'add-entity-modal-label',
  addEntityModalValue: 'add-entity-modal-value',
  viewActionPill: 'view-action-pill',
  actionWrapperPill: 'action-wrapper-pill',
  roleLabelModalContainer: 'role-label-modal-container',
  roleValueModalContainer: 'role-value-modal-container'
};
exports.classes = classes;
var translatedStrings = {
  allUsers: (0, _externalization.translate)('POLICIES_MODULE.ALL_USERS'),
  allTags: (0, _externalization.translate)('POLICIES_MODULE.ALL_TAGS'),
  allServiceIdentities: (0, _externalization.translate)('POLICIES_MODULE.ALL_SERVICE_IDENTITIES'),
  allTokens: (0, _externalization.translate)('POLICIES_MODULE.ALL_TOKENS'),
  cloneText: (0, _externalization.translate)('CLONE'),
  mainRoleText: (0, _externalization.translate)('MAIN'),
  inlineText: (0, _externalization.translate)('INLINE'),
  inactiveText: (0, _externalization.translate)('INACTIVE_TEXT'),
  preDefinedText: (0, _externalization.translate)('PRE_DEFINED'),
  policyJsonText: (0, _externalization.translate)('POLICIES_MODULE.POLICY_JSON_FORMAT'),
  deleteText: (0, _externalization.translate)('POLICIES_MODULE.DELETE_POLICY'),
  cloneMessage: (0, _externalization.translate)('POLICIES_MODULE.POLICY_CLONE'),
  loadingMessage: (0, _externalization.translate)('POLICIES_LOADING'),
  pageTitle: (0, _externalization.translate)('POLICY'),
  roleTitle: (0, _externalization.translate)('ROLE'),
  permissionTitle: (0, _externalization.translate)('PERMISSION'),
  editText: (0, _externalization.translate)('EDIT'),
  disableText: (0, _externalization.translate)('DISABLE'),
  enableText: (0, _externalization.translate)('ENABLE'),
  deleteLabel: (0, _externalization.translate)('DELETE'),
  closeLabel: (0, _externalization.translate)('CLOSE'),
  viewJson: (0, _externalization.translate)('VIEW_JSON'),
  viewEntity: (0, _externalization.translate)('VIEW_ENTITY'),
  permissionName: (0, _externalization.translate)('PERMISSION_NAME'),
  sourceName: (0, _externalization.translate)('ROLES_MODULE.SOURCE'),
  description: (0, _externalization.translate)('DESCRIPTION'),
  consumer: (0, _externalization.translate)('ROLES_MODULE.CONSUMER'),
  actions: (0, _externalization.translate)('ROLES_MODULE.ACTIONS'),
  resources: (0, _externalization.translate)('RESOURCES'),
  actionText: (0, _externalization.translate)('ACTION'),
  permissionText: (0, _externalization.translate)('PERMISSIONS'),
  rolesLabel: (0, _externalization.translate)('ROLES'),
  deletePolicyConfirmMessage: (0, _externalization.translate)('POLICIES_MODULE.DELETE_POLICY_CONFIRM_MESSAGE'),
  roleName: (0, _externalization.translate)('ROLES_MODULE.ROLE_NAME'),
  copyText: (0, _externalization.translate)('COPY'),
  yesDeleteText: (0, _externalization.translate)('YES_DELETE'),
  noText: (0, _externalization.translate)('NO'),
  yesText: (0, _externalization.translate)('YES'),
  noneText: (0, _externalization.translate)('NONE'),
  copyMessage: (0, _externalization.translate)('COPY_NOTIFICATION_MESSAGE'),
  policyName: (0, _externalization.translate)('POLICIES_MODULE.POLICY_NAME'),
  accessType: (0, _externalization.translate)('POLICIES_MODULE.ACCESS_TYPE'),
  enableLoadingMessage: (0, _externalization.translate)('POLICIES_MODULE.ENABLE_LOADING_MESSAGE'),
  disableLoadingMessage: (0, _externalization.translate)('POLICIES_MODULE.DISABLE_LOADING_MESSAGE'),
  viewTooltip: (0, _externalization.translate)('POLICIES_MODULE.VIEW_ROLE_POLICY_TOOLTIP'),
  viewPermissionTooltip: (0, _externalization.translate)('PERMISSION_MODULE.VIEW_PERMISSION_TOOLTIP'),
  hours: function hours(_hours) {
    return (0, _externalization.translate)('HOURS', {
      hours: _hours
    });
  },
  minutes: function minutes(_minutes) {
    return (0, _externalization.translate)('MINUTES', {
      minutes: _minutes
    });
  },
  errorPolicyViewData: function errorPolicyViewData(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.VIEW_POLICY_ERROR_MESSAGE_WITH_REASON', {
      reason: reason
    });
  },
  days: (0, _externalization.translate)('DAYS'),
  startAndEndDateTime: (0, _externalization.translate)('POLICIES_MODULE.START_AND_END_DATE_TIME'),
  dateTimeSchedule: (0, _externalization.translate)('POLICIES_MODULE.DATE_TIME_SCHEDULE')
};
exports.translatedStrings = translatedStrings;
var policyConstantLabels = {
  defaultButtonSize: '24',
  viewPolicyButtonTestId: 'view-policy',
  permissionTableTestId: 'permission-table',
  roleTableTestId: 'role-table'
};
exports.policyConstantLabels = policyConstantLabels;
var memberLabels = {
  user: (0, _externalization.translate)('POLICIES_MODULE.USERS'),
  tags: (0, _externalization.translate)('POLICIES_MODULE.TAGS'),
  identities: (0, _externalization.translate)('POLICIES_MODULE.SERVICE_IDENTITIES'),
  tokens: (0, _externalization.translate)('POLICIES_MODULE.API_TOKENS')
};
exports.memberLabels = memberLabels;
var conditionsLabels = {
  ip: (0, _externalization.translate)('POLICIES_MODULE.IP_ADDRESS'),
  startTime: (0, _externalization.translate)('POLICIES_MODULE.START_TIME_LABEL'),
  endTime: (0, _externalization.translate)('POLICIES_MODULE.END_TIME_LABEL'),
  startDate: (0, _externalization.translate)('POLICIES_MODULE.START_DATE_TIME_LABEL'),
  endDate: (0, _externalization.translate)('POLICIES_MODULE.END_DATE_TIME_LABEL'),
  startAndEndDateTime: (0, _externalization.translate)('POLICIES_MODULE.START_AND_END_DATE_TIME'),
  dateTimeSchedule: (0, _externalization.translate)('POLICIES_MODULE.DATE_TIME_SCHEDULE'),
  stepUpVerificationEnabled: (0, _externalization.translate)('POLICIES_MODULE.STEP_UP_VERIFICATION_VIEW_LABEL'),
  stepUpVerificationAlwaysPrompt: (0, _externalization.translate)('POLICIES_MODULE.STEP_UP_VERIFICATION_ALWAYS_PROMPT_VIEW_LABEL')
};
exports.conditionsLabels = conditionsLabels;
var approvalLabels = {
  approvalRequired: (0, _externalization.translate)('POLICIES_MODULE.APPROVAL_REQUIRED'),
  notification: (0, _externalization.translate)('POLICIES_MODULE.NOTIFICATION_MEDIUM'),
  type: (0, _externalization.translate)('POLICIES_MODULE.APPROVER_TYPE'),
  approvers: (0, _externalization.translate)('POLICIES_MODULE.APPROVERS'),
  time: (0, _externalization.translate)('POLICIES_MODULE.MAXIMUM_TIME'),
  userListLabel: (0, _externalization.translate)('POLICIES_MODULE.USER_LIST_LABEL'),
  tagListLabel: (0, _externalization.translate)('POLICIES_MODULE.TAG_LIST_LABEL'),
  channelListLabel: (0, _externalization.translate)('POLICIES_MODULE.CHANNEL_LIST_LABEL'),
  maxValidTimeLabel: (0, _externalization.translate)('POLICIES_MODULE.ACCESS_VALIDITY_AFTER_APPROVAL_LABEL'),
  managerApprovalLabel: (0, _externalization.translate)('POLICIES_MODULE.MANAGER_APPROVAL_MANDATORY')
};
exports.approvalLabels = approvalLabels;
var viewPolicyHeaders = {
  general: (0, _externalization.translate)('POLICIES_MODULE.GENERAL'),
  members: (0, _externalization.translate)('POLICIES_MODULE.MEMBERS'),
  generic: (0, _externalization.translate)('POLICIES_MODULE.GENERIC_CONDITIONS'),
  stepUpVerification: (0, _externalization.translate)('POLICIES_MODULE.STEP_UP_VERIFICATION'),
  approvals: (0, _externalization.translate)('POLICIES_MODULE.APPROVALS')
};
exports.viewPolicyHeaders = viewPolicyHeaders;
var dateFormat = 'DD/MM/YYYY h:mm A';
exports.dateFormat = dateFormat;
var timeFormat = 'h:mm A';
exports.timeFormat = timeFormat;
var inactiveStatus = 'inactive';
exports.inactiveStatus = inactiveStatus;
var routeToNameList = [{
  name: 'System Administrator',
  route: '/admin'
}, {
  name: 'Role & Policy Management',
  route: '/admin/policy-management'
}, {
  name: 'Policy',
  route: '/admin/policy-management/policies'
}, {
  name: (0, _externalization.translate)('VIEW'),
  route: '/admin/policy-management/policies/view'
}];
exports.routeToNameList = routeToNameList;
var policyButton = {
  variant: 'primary',
  secVariant: 'secondary',
  size: 'medium'
};
exports.policyButton = policyButton;

var getTogglePolicyConfirmTitle = function getTogglePolicyConfirmTitle(currentStatus) {
  return currentStatus === enabledPolicy ? (0, _externalization.translate)('POLICIES_MODULE.TOGGLE_POLICY_CONFIRM_TITLE_DISABLE') : (0, _externalization.translate)('POLICIES_MODULE.TOGGLE_POLICY_CONFIRM_TITLE_ENABLE');
};

exports.getTogglePolicyConfirmTitle = getTogglePolicyConfirmTitle;

var getTogglePolicyConfirmMessage = function getTogglePolicyConfirmMessage(currentStatus) {
  return currentStatus === enabledPolicy ? (0, _externalization.translate)('POLICIES_MODULE.TOGGLE_POLICY_CONFIRM_MESSAGE_DISABLE') : (0, _externalization.translate)('POLICIES_MODULE.TOGGLE_POLICY_CONFIRM_MESSAGE_ENABLE');
};

exports.getTogglePolicyConfirmMessage = getTogglePolicyConfirmMessage;

var getTogglePolicySuccessMessage = function getTogglePolicySuccessMessage(currentStatus) {
  return currentStatus === enabledPolicy ? (0, _externalization.translate)('POLICIES_MODULE.TOGGLE_POLICY_SUCCESS_MESSAGE_DISABLE') : (0, _externalization.translate)('POLICIES_MODULE.TOGGLE_POLICY_SUCCESS_MESSAGE_ENABLE');
};

exports.getTogglePolicySuccessMessage = getTogglePolicySuccessMessage;

var getTogglePolicyErrorMessage = function getTogglePolicyErrorMessage(currentStatus, reason) {
  return currentStatus === enabledPolicy ? (0, _externalization.translate)('POLICIES_MODULE.TOGGLE_POLICY_ERROR_MESSAGE_DISABLE') : (0, _externalization.translate)('ERROR_MESSAGE', {
    reason: reason
  });
};

exports.getTogglePolicyErrorMessage = getTogglePolicyErrorMessage;

var getTogglePolicyLabel = function getTogglePolicyLabel(currentStatus) {
  var toggleLabel = currentStatus === enabledPolicy ? (0, _externalization.translate)('YES_DISABLE') : (0, _externalization.translate)('YES_ENABLE');
  return toggleLabel;
};

exports.getTogglePolicyLabel = getTogglePolicyLabel;
var enabledPolicy = (0, _externalization.translate)('ENABLED');
exports.enabledPolicy = enabledPolicy;
var disabledPolicy = (0, _externalization.translate)('DISABLED');
exports.disabledPolicy = disabledPolicy;
var tenantAdminPolicyName = 'TenantAdminPolicy';
exports.tenantAdminPolicyName = tenantAdminPolicyName;
var roleFields = [{
  key: 'consumer',
  label: (0, _externalization.translate)('CONSUMER')
}, {
  key: 'resources',
  label: (0, _externalization.translate)('RESOURCES')
}, {
  key: 'actions',
  label: (0, _externalization.translate)('ROLES_MODULE.ACTIONS')
}];
exports.roleFields = roleFields;
var appsConsumer = 'apps';
exports.appsConsumer = appsConsumer;
var papConsumer = 'papservice';
exports.papConsumer = papConsumer;